var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 17,
    viewBox: "0 0 114 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "thila",
    x1: 0.25,
    x2: 16.25,
    y1: 8.26,
    y2: 8.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "thilb",
    x1: 25.25,
    x2: 41.25,
    y1: 8.26,
    y2: 8.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "thilc",
    x1: 50.25,
    x2: 66.25,
    y1: 8.26,
    y2: 8.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "thild",
    x1: 75.25,
    x2: 91.25,
    y1: 8.26,
    y2: 8.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "thile",
    x1: 100.25,
    x2: 113.25,
    y1: 8.26,
    y2: 8.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a928"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#thila)",
    d: "M13.113 15.833c-.57.405-4.222-2.165-4.921-2.17-.7-.006-4.393 2.505-4.956 2.09-.562-.414.76-4.672.55-5.337C3.575 9.75.038 7.024.26 6.362c.222-.661 4.691-.723 5.26-1.128C6.09 4.828 7.599.632 8.298.638c.7.005 2.14 4.225 2.702 4.64.563.414 5.031.548 5.242 1.213.21.665-3.37 3.335-3.59 3.996-.222.662 1.031 4.94.462 5.346z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#thilb)",
    d: "M38.113 15.833c-.57.405-4.222-2.165-4.921-2.17-.7-.006-4.393 2.505-4.956 2.09-.562-.414.76-4.672.55-5.337-.211-.665-3.748-3.392-3.526-4.054.222-.661 4.691-.723 5.26-1.128.57-.406 2.078-4.602 2.777-4.596.7.005 2.14 4.225 2.702 4.64.563.414 5.031.548 5.242 1.213.21.665-3.37 3.335-3.59 3.996-.222.662 1.031 4.94.462 5.346z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#thilc)",
    d: "M63.113 15.833c-.57.405-4.222-2.165-4.921-2.17-.7-.006-4.393 2.505-4.956 2.09-.562-.414.76-4.672.55-5.337-.211-.665-3.748-3.392-3.526-4.054.222-.661 4.691-.723 5.26-1.128.57-.406 2.078-4.602 2.777-4.596.7.005 2.14 4.225 2.702 4.64.563.414 5.031.548 5.242 1.213.21.665-3.37 3.335-3.59 3.996-.222.662 1.031 4.94.462 5.346z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#thild)",
    d: "M88.113 15.833c-.57.405-4.222-2.165-4.921-2.17-.7-.006-4.393 2.505-4.956 2.09-.562-.414.76-4.672.55-5.337-.211-.665-3.748-3.392-3.526-4.054.222-.661 4.691-.723 5.26-1.128.57-.406 2.078-4.602 2.777-4.596.7.005 2.14 4.225 2.702 4.64.563.414 5.031.548 5.242 1.213.21.665-3.37 3.335-3.59 3.996-.222.662 1.031 4.94.462 5.346z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#thile)",
    d: "M103.43 16.2a.292.292 0 0 1-.18-.048c-.327-.253-.018-1.874.255-3.305.198-1.04.385-2.021.296-2.316-.089-.296-.782-.987-1.517-1.72-1.01-1.006-2.153-2.146-2.024-2.549s1.698-.596 3.083-.767c1.008-.124 1.96-.242 2.2-.422.242-.18.657-1.084 1.096-2.04.603-1.312 1.286-2.8 1.693-2.8.098.001.218.09.355.266v13.6c-.215-.1-.365-.148-.46-.15-.302 0-1.146.477-2.039.981l-.257.145c-1.013.57-2.04 1.125-2.5 1.125zm9.567.081c-.138 0-.331-.051-.59-.156h.843a.268.268 0 0 1-.08.11.285.285 0 0 1-.173.046z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.dabe78cf1485795f89e281bcc5d95439.svg";
export { ForwardRef as ReactComponent };